var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { RangeDatePickerWithPeriod } from '@web/components/layout/DatePicker/RangeDatePicker';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { useLocation } from 'react-router-dom';
export function PeriodFilter(_a) {
    var _b = _a.isVisible, isVisible = _b === void 0 ? true : _b, _c = _a.isDisplayLabel, isDisplayLabel = _c === void 0 ? true : _c, _d = _a.className, className = _d === void 0 ? 'w-full sm:max-w-72' : _d;
    var filters = useFilters();
    var navigateTo = useNavigateTo();
    var location = useLocation();
    function onChange(period, dateFrom, dateTo) {
        navigateTo({
            pathname: location.pathname,
            newFilters: {
                period: period,
                dateFrom: dateFrom.toISOString(),
                dateTo: dateTo.toISOString()
            }
        });
    }
    return isVisible ? (_jsx("div", __assign({ className: className }, { children: _jsx(RangeDatePickerWithPeriod, { isDisplayLabel: isDisplayLabel, onChange: onChange, period: filters.period || 'month', dateFrom: new Date(filters.dateFrom), dateTo: new Date(filters.dateTo) }) }))) : null;
}
